import React from 'react';
import Contact from './Contact';
import Footer from './Footer';
import Hero from './Hero';
import Navbar from './Navbar';
import Projects from './Projects';
import Skill from './Skill';
import SkillCourse from './SkillCourse';
import SliderProjects from './SliderProjects';
import AboutMore from './AboutMore';
import ProjectHover from './ProjectHover';
import TimeLine from './timeline/TimeLine';
import ProfessionalWorks from './ProfessionalWorks';



const Home = () => {
    return (
        <div className='container'>

            
            <Navbar/>
            <Hero/>
            <AboutMore/>
            <TimeLine/>
            <Skill/>
           
            <Projects/>
            <ProjectHover/>
            <SliderProjects />
            <SkillCourse />
            
            <ProfessionalWorks/>
            <Contact/>  
            <Footer/>
          
        
        </div>
    );
};

export default Home;